export default {
    tabbar: {
        home: 'Startseite',
        trading: 'Transaktion',
        invest: 'Investments',
        share: 'Teilen',
        mine: 'mein'
    },
    common: {
        deposit: 'Kaution',
        withdrawal: 'Zeichnung',
        share: 'Teilen',
        team: 'Team',
        task: 'Aufgabe',
        addr: 'Adresse',
        logout: 'Abmelden',
        wallet: 'Brieftasche',
        account: 'Konto',
        promotion: 'Erweiterung',
        details: 'Details',
        dailyRevenue: 'Tägliche Einnahmen',
        dailyRevenueList: 'Tägliche Einnahmenliste',
        aboutUs: 'Über uns',
        globalPartners: 'Globale Partner',
        totalBalance: 'Gesamtsaldo',
        profitList: 'Liste der finanziellen Erträge',
        notification: 'Mitteilung',
        previous: 'Vorherige',
        close: 'Herunterfahren',
        next: 'Nächster',
        investWallet: 'Investment Wallet',
        financialWallet: 'Finanzielle Geldbörse',
        recharge: 'Aufladen',
        copySucceeded: 'Kopieren erfolgreich',
        copyFailed: 'Kopieren fehlgeschlagen',
        promotionWallet: 'Promotion Wallet',
        registerRewardWallet: 'Belohnung registrieren Wallet',
        toAddress: 'TRON Wallet Adresse für Abholung (beginnend mit T)',
        verifyYourPassword: 'Passwort bestätigen',
        serviceFee: 'Gas fees',
        confirm: 'Bestätigen',
        submitted: 'Eingereicht',
        date: 'Datum',
        amount: 'Betrag',
        accountAvailableBalance: 'Verfügbarer Kontostand',
        securityPassword: 'Sicherheitspasswort',
        withdrawalPrincipal: 'Entzug des Kapitals',
        withdrawalProfit: 'Gewinnentzug',
        profitRate: 'Zinsrate',
        notificationAndFAQ: 'FAQ und Hinweise',
        FAQ: 'FAQ',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:Projektmerkmale/Einführung',
                content: `R:
1. Als erster und bewährter geprüfter Investitionskodex der Branche zielt unsere Lösung darauf ab, zu beweisen, dass intelligente Verträge die Zukunft des Investierens sind. Seine Langlebigkeit und Stabilität werden letztendlich die Kryptoindustrie und die Art und Weise, wie Menschen über Investitionen und Handel denken, revolutionieren. Die herkömmliche Token-Industrie steht vor vielen Herausforderungen, darunter Token-Betrug, Betrug, Marktvolatilität, unehrliche Entwickler, die Benutzergelder stehlen, und mangelnde Liquidität.

2. Der Zuverlässigkeitscode, den wir haben, basiert auf der Struktur der Lösung und unsere Lösung wird von diesen und vielen anderen Herausforderungen, die in der Kryptoindustrie auftreten, in keiner Weise beeinträchtigt. Unsere Plattform erfordert keine Marktliquidität. Daher sind Ihre Investition und Ihr erwartetes Einkommen sicher, da wir nicht von Veränderungen in der Branche abhängig sind. Stattdessen haben wir eine Lösung entwickelt, die auf der Attraktivität neuer Benutzer basiert, aber auf intelligenten Verträgen basiert! Unser Code und unsere Struktur sind sicher, mit garantierter Langlebigkeit und Transparenz. Daher verfügen wir über ein sehr attraktives und robustes Empfehlungsprogramm mit detaillierten und transparenten Statistiken für jeden Promoter/Benutzer. Die Einnahmen des Auftraggebers sowie die anderer Benutzer werden sofort zum Profil hinzugefügt, und im Gegensatz zu anderen DeFi-Investitionslösungen können Benutzer jederzeit sofort Geld abheben.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:Was ist unser Vorteil?',
                content: `R:Unsere Systeme werden vom Haze-Sicherheitsteam geprüft und verfügen über unabhängige Smart-Contract-Prüfer
1. Sicher und zuverlässig: Es ist kein Währungstransfer erforderlich, USDT wird ohne Risiko in Ihr eigenes Wallet eingezahlt
2. Professionelle Stabilität: professionelles Team, stabiler Betrieb das ganze Jahr über
3. Niedrige Eintrittsschwelle: Teilen Sie die Node-Mining-Einnahmen
4.USD ETHW AI Strategy-C Mining Pool: Keine Notwendigkeit, Währung zu transferieren, stabiles Einkommen
5. Wir sind bestrebt, die weltweit größte integrierte DeFi-Plattform DEX, IMO und DAO aufzubauen`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:Wie kann ich mich engagieren?',
                content: `R:
1. Das Wallet befindet sich in der Kette und die Wallet-Station ist mit einem Dapp-Browser ausgestattet.
2. Verbinden Sie TRC20 mit USDT und zahlen Sie es in Ihr Wallet ein
3. Geben Sie Gongwang über den Wallet-Browser ein
4. Um an diesem Projekt teilnehmen zu können, müssen in Ihrem Wallet mehr als 30 Trx an Mining-Gebühren vorhanden sein
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:Wie lange dauert die Teilnahme am Mining?',
                content: `R:Die Zeit lässt sich nicht berechnen. Normalerweise kann es innerhalb von 4 Stunden abgeschlossen werden. Wenn andere unsichere Gründe vorliegen, kann die Frist verlängert werden.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:Warum müssen wir Mining-Gebühren zahlen, um Gewinne auszuzahlen?',
                content: `R:Denn bei diesem Prozess der Teilnahme am Mining werden die Kunden nur namentlich gezählt und die anfallenden Mining-Gebühren wurden von den Minern bezahlt. Die erzielten Einnahmen befinden sich tatsächlich im Vertragspool, und nur durch die Zahlung von Mining-Gebühren können Sie sie gegen Einnahmen eintauschen.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:Wie kann man Gewinne abheben?',
                content: `R:Nachdem Sie USDT erhalten haben, müssen Sie für Transaktionsgebühren eine kleine Menge TRX in Ihrer Brieftasche haben. Sie müssen nur einmal bezahlen und der USDT-Umtausch wird innerhalb eines gesetzlichen Werktages abgeschlossen. Wenn Sie eine Auszahlung veranlassen, wird die USDT-Auszahlung automatisch an die Wallet-Adresse des Knotens gesendet, dem Sie beigetreten sind. Andere Adressen werden nicht unterstützt.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:Was ist Defi Liquidity Mining?',
                content: `R:Liquidity Mining ist eine Art der dezentralen DeFi-Finanzierung. Es muss keine Grafikkarten kaufen, keine Rechenleistung beisteuern oder teure Stromrechnungen bezahlen, sondern erwirtschaftet Einnahmen durch die Bereitstellung von Geldern und Liquidität. Vor allem in letzter Zeit schwankten die Währungspreise stark. Für einige engagierte Coin-Inhaber ist Liquidity Mining eine Möglichkeit, Einkommen zu erzielen und mehr Kryptowährung anzuhäufen, ohne dass Transaktionen erforderlich sind.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:Wie funktioniert es?',
                content: `R:Unsere Lösung ist eine computergestützte Transaktionsvereinbarung, die die Bedingungen eines Vertrags zwischen zwei Parteien automatisch durchsetzt. Ähnlich wie bei Universalverträgen müssen beide Nutzer auf unserer Plattform die Regeln und Teilnahmebedingungen beim Handel festlegen. Sobald eine Einigung erzielt und ein intelligenter Vertrag ins Leben gerufen wurde, funktioniert er wie vorgesehen, ohne dass die Möglichkeit besteht, dass sich die vorgegebenen Bedingungen ändern. Wenn ein Benutzer eine Aktivität im Mining-Pool eines Blockchain-Knotens initiiert, muss im Vertrag ein verfügbares Guthaben vorhanden sein. Der Rest der Benutzer überlässt es der Vertragsausführung und muss nicht mehr stundenlang warten, um zu prüfen, wann sie verkaufen oder kaufen sollen. Daher ist gemäß den Vertragsbedingungen garantiert, dass der Wert Ihrer Investition niemals sinkt; im Gegenteil, es bringt unseren Nutzern 100 % Gewinn.`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: 'Der Entnahmebetrag muss größer sein als die verbrauchte Gasgebühr',
        supportTips: 'Sehr geehrter Benutzer, wir haben für Sie einen exklusiven Mining-Pool-Assistentendienst eingerichtet. Sie können uns für Beratung, Beschwerden, Vorschläge usw. schreiben und wir werden Ihnen innerhalb von 24 Stunden antworten und die Angelegenheit bearbeiten!',
        tips: 'Tipps',
        Withdrawals_prohibited: 'Die Auszahlungsbedingungen sind derzeit nicht erfüllt, bitte schließen Sie zuerst die Aufgabe ab.'
    },
    homePage: {
        theCommonProblem: 'Häufig gestellte Fragen',
        latestAnnouncement: 'Letzte Ankündigung',
        block5title: 'Werden Sie Tron Millionär',
        block5desc: 'Verwenden Sie Cloud Mining und Defi-Technologie, um sicherzustellen, dass alle Benutzer den höchsten USDT-Umsatz erzielen。',
        block6title: 'Anzeige von Plattformdaten',
        accumulatedProfit: 'Kumuliertes Einkommen',
        membership: 'Mitgliedschaft',
        block7title: 'Wir sind am besten',
        block7desc: 'hako ist ein in Singapur registriertes Unternehmen, Lizenznummer: PS20200556. Wir sind die einzige geprüfte und verifizierte Website für Smart-Contract-Investitionen im Kryptowährungsbereich, die im TRON Smart Chain (TRON)-Netzwerk betrieben wird. Hako Cloud Mining bietet eine potenziell kostengünstige Mining-Pipeline für Bitcoin USDT und andere Kryptowährungen. Gleichzeitig ermöglichen Ihnen sowohl der quantitative Handel als auch die DeFi-Technologie, mit einem geringen Kapitalbetrag problemlos an Blockchain-Transaktionen teilzunehmen und stabile Einnahmen wie Versicherungen zu erzielen.',
        tzl: 'investiert',
        zl: 'verdienste'
    },
    investPage: {
        productList: 'Produktliste',
        investedList: 'Investitionsliste',
        dailyRate: 'Tageszinssatz',
        cycle: 'Zyklus',
        day: 'Tag',
        productDetails: 'Produktdetails'
    },
    tradingPage: {
        miningWorking: 'Cloud Mining funktioniert',
        tradingProfit: 'Erträge aus Transaktionen',
        settlementRule: '24-Stunden-Abrechnung',
        viewAll: 'Alle anzeigen',
        quantifyingTransactionRevenue: 'Qualitative Handelserträge',
        receive: 'empfangen',
        received: 'Empfangen',
        rule: 'Bergbauregeln',
        rules: 'Wenn Sie möchten, dass „Cloud Mining“ funktioniert und Sie ein tägliches Einkommen erzielen, aktivieren Sie es bitte in „Financial Wallet“. Wenn das USDT-Guthaben in Ihrem Wallet bestimmte Bedingungen erfüllt, erhalten Sie ein tägliches Einkommen und das generierte Einkommen wird 30 Tage lang einbehalten. Bitte klicken Sie, um es rechtzeitig einzufordern. Berechnen Sie Ihren täglichen Umsatzprozentsatz anhand der folgenden Tabelle:',
        profit: 'Profitieren',
        miningNotWorking: 'Cloud Mining funktioniert nicht, bitte aktivieren Sie es',
        balance: 'Gleichgewicht'
    },
    sharePage: {
        text1: 'Laden Sie Ihre Kontakte ein',
        text2: 'Oder Freunde und Belohnungen erhalten',
        text3: 'Empfehlen und Belohnungen erhalten',
        text4: 'Teilen Sie Ihre empfohlenen Links und beginnen Sie Geld zu verdienen',
        copyLink: 'Verbindung kopieren'
    },
    minePage: {
        trxDepositInvestment: 'USDT-Anlagedepot',
        trxDepositFinancial: 'USDT Finanzeinlage',
        tips: 'Zahle beliebig viele USDT ein, um das Konto zu aktivieren und die Auszahlungsfunktion zu aktivieren',
        appServices: 'Anwendungsservice'
    },
    depositPage: {
        text1: 'Es gibt zwei Investitionsarten',
        text2: '1:Laden Sie das Investment Wallet auf, Sie können Einnahmen nach verschiedenen Zyklen erhalten und das Kapital und das Einkommen bei Fälligkeit zurückgeben',
        text3: '2:Aktivieren Sie die „Cloud-Mining“-Funktion in Ihrem Finanzportfolio und erhalten Sie täglich Einnahmen gemäß der Zeitzone Singapurs (nach 12 Uhr).',
        text4: 'Anmerkungen:',
        text5: 'Bevor Sie investieren, wählen Sie bitte ein Anlagekonto oder ein Finanzkonto nach Ihren Anlagebedürfnissen. Bitte warten Sie darauf, bis das Konto aufgeladen ist. Dies ist ein sehr kritisches Thema。'
    },
    rechargePage: {
        trxAddress: 'TRC20-USDT Adresse',
        copyAddress: 'Adresse kopieren',
        tips1: 'Bitte laden Sie keine anderen nicht USDT Assets auf. Aufzeichnung etwa 5,10 Minuten nach dem Aufladen。',
        tips2: 'Wenn es lange Zeit nicht geliefert wurde, aktualisieren Sie bitte diese Seite. Mindestinvestitionen von 5 USDT。',
        rechargeCompleted: 'Aufladung abgeschlossen',
        inactivated: 'Inaktiviert',
        activated: 'Aktiviert',
        tips3: 'Sie müssen nicht wiederholt klicken. Cloud Mining beginnt etwa 5 bis 10 Minuten nach dem Absenden der Anfrage zu funktionieren.',
        tips4: 'Wenn es längere Zeit nicht aktiviert wurde, klicken Sie bitte erneut auf die Schaltfläche „Aktivieren“.',
        ActivateCloudMining: 'Aktivieren Sie Cloud Mining'
    },
    withdrawalPage: {
        text1: 'Grundkontensaldo (USDT)',
        text2: 'Die Auszahlung erfolgt innerhalb von 24-Stunden',
        dailyWithdrawalLimit: 'Tägliche Auszahlungslimits',
        unlimit: 'unbegrenzt'
    },
    teamPage: {
        intro: 'Benutzer, die Sie direkt und indirekt einladen, können Dividenden für Sie erzielen. Angenommen, Sie laden Benutzer A ein, die von Benutzer A erzielten finanziellen Einnahmen werden als prozentuale Belohnung an Ihr Wallet gesendet. Wenn Benutzer A Benutzer B einlädt und B wiederum C einlädt, können Sie eine prozentuale Belohnung von A ({lev2rate}%), B ({lev3rate}%) und C ({lev4rate}%) des Benutzereinkommens erhalten!',
        level: 'Hierarchie',
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: 'Zahl',
        rewards: 'Belohnung'
    },
    productDetailsPage: {
        startingAmount: 'Anfangsbetrag',
        maxInvestmentAmount: 'Maximale Investition',
        dailyInterestRate: 'Tageszinssatz',
        investableQuantity: 'Investitionsmenge',
        investmentAmount: 'Investitionsbetrag',
        participateInInvestment: 'Beteiligung an Investitionen'
    },
    investedListPage: {
        investmentTime: 'Investitionszeit',
        settlementTime: 'Abrechnungszeit',
        settlementAmount: 'Abrechnungsbetrag'
    },
    loginPage: {
        MobileNumber: 'Telefonnummer',
        LoginPassword: 'Login Passwort',
        SignIn: 'Anmelden',
        SignUp: 'registrieren',
        rememberThePassword: 'Passwort merken',
        inviteCode: 'Einladungscode',
        captcha: 'Prüfcode',
        EncryptedRegistration: 'Verschlüsselung Registrierung',
        desc: 'Passwörter werden in einer dezentralen Pipeline gespeichert und können nach ihrem Verlust nicht abgerufen werden. Bitte merken Sie sich Ihr Passwort。 ',
        registerSuccess: 'Konto erfolgreich erstellt'
    },
    taskPage: {
        desc: 'Jeder effektive Aufladebetrag der untergeordneten Mitglieder, die Sie zur Registrierung einladen, wird in einem bestimmten Verhältnis in Ihr Auszahlungslimit (Promotion-Prämienkonto) umgerechnet.',
        rwconvertRate: 'Umrechnungsskala',
        totalLimit: 'Kumulierter Grenzwert',
        availableLimit: 'Verfügbare Gutschrift',
        contactService: 'Kontaktieren Sie den Kundenservice'
    },
    Please_unlock_your_wallet: 'Bitte entsperren Sie Ihr Wallet',
    Please_open_the_website_in_the_Dapp_browser: 'Bitte öffnen Sie die Website im Dapp-Browser'
}
